import { Component, OnInit } from '@angular/core';
import { RestapiService } from '../../services/restapi.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  isLogged: boolean;
  loggedUsername: string | null = null;

  // Tracking variable for the mobile hamburger state
  isMenuOpen = false;

  constructor(private service: RestapiService, public router: Router) { }

  ngOnInit(): void {
    this.isLogged = this.service.isLogged();
    this.loggedUsername = localStorage.getItem(this.service.USER_NAME_ATTRIBUTE_NAME);
  }

  // Toggles mobile menu drawer open/closed
  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  // Safely shuts drawer when a route changes
  closeMenu(): void {
    this.isMenuOpen = false;
  }

  navigateToLogin(): void {
    this.closeMenu(); // Closes menu drawer if clicking on mobile login action
    this.router.navigate(['/login']).then(nav => { console.log(nav); });
  }

  doLogout(): void {
    this.closeMenu();
    this.service.logout();
    window.location.reload();
  }
}
